<template>
  <div class="about">
    <Header />
    <Hero step="fahrt" />
    <FahrtAuswahl />
    <ReservationFee />
    <AnzahlReservierung />
    <BergfahrtUhrzeit />
    <TalfahrtUhrzeit />
    <SubsetUhrzeit />
    <Footer />
    <SlideNavigation />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import FahrtAuswahl from '@/components/FahrtAuswahl.vue'
import BergfahrtUhrzeit from '@/components/BergfahrtUhrzeit.vue'
import TalfahrtUhrzeit from '@/components/TalfahrtUhrzeit.vue'
import AnzahlReservierung from '@/components/AnzahlReservierung.vue'
import Footer from '@/components/Footer.vue'
import SlideNavigation from '@/components/SlideNavigation.vue'
import ReservationFee from "@/components/ReservationFee.vue";
import SubsetUhrzeit from "../components/SubsetUhrzeit.vue";

export default {
  name: 'FahrtView',
  components: {
    SubsetUhrzeit,
    ReservationFee,
    Header,
    Hero,
    FahrtAuswahl,
    AnzahlReservierung,
    BergfahrtUhrzeit,
    TalfahrtUhrzeit,
    Footer,
    SlideNavigation
  },
  data() {
    return {}
  },
  mounted() {
  }
}
</script>
